import ContactMailIcon from "@mui/icons-material/ContactMail";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { PageHeader } from "common";
import { selectProfile } from "features/profile/profileSlice";

export default function PartnerContact() {
  const profile = useAppSelector(selectProfile);
  const accountManager = profile?.partner?.account_manager;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <PageHeader avatar={<ContactMailIcon />} title="Kapcsolat" />

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Ügyfélszolgálat
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <EmailIcon color="action" />
            <Typography>hello@silver-line.hu</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <PhoneIcon color="action" />
            <Typography>+36 20 332 53 64</Typography>
          </Box>
        </Box>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Kapcsolattartó
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {accountManager ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Typography variant="subtitle1" fontWeight="medium">
              {accountManager.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <EmailIcon color="action" />
              <Typography>{accountManager.email}</Typography>
            </Box>
            {accountManager.phone && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <PhoneIcon color="action" />
                <Typography>{accountManager.phone}</Typography>
              </Box>
            )}
          </Box>
        ) : (
          <Typography color="text.secondary">
            Nincs hozzárendelt kapcsolattartó.
          </Typography>
        )}
      </Paper>
    </Box>
  );
}
